(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredients-alphabets"] && !Shopify.designMode) return;
  try {
    
  //let anchors = document.querySelectorAll('[data-offset]');
  //let announcement_h = document.querySelector('#section-announcement').clientHeight;
  //let header_h = document.querySelector('#section-header').clientHeight;
  //let offset_h = header_h + announcement_h;

  //anchors.forEach(function(el) {
  //  el.setAttribute('data-offset', offset_h);
  //});

 //  let alphabet = document.querySelectorAll('.template_page-ingredients #ingredientList-alpha [data-letter]');
 //  alphabet.forEach(function(letter) {
 //    var start = letter.getAttribute('data-letter');
 //    var ing = document.querySelector('.template_page-ingredients .ingredientList--ingredient[id^="'+start+'"]');
	// if (ing != null) {
	//   var anchor = ing.getAttribute('id');
	//   var a = document.createElement('a');
	//   a.setAttribute('href', '#' + anchor);
	//   a.setAttribute('data-offset', 200);
	//   letter.parentNode.insertBefore(a, letter);
	//   a.appendChild(letter);
 //      document.getElementById('#' + anchor).scrollIntoView({
 //        behavior: 'smooth'
 //      });
	// }
 //  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  //let anchors = document.querySelectorAll('[data-offset]');
  //let announcement_h = document.querySelector('#section-announcement').clientHeight;
  //let header_h = document.querySelector('#section-header').clientHeight;
  //let offset_h = header_h + announcement_h;

  //anchors.forEach(function(el) {
  //  el.setAttribute('data-offset', offset_h);
  //});

  let alphabet = document.querySelectorAll('#ingredientList-alpha [data-letter]');
  alphabet.forEach(function(letter) {
    var start = letter.getAttribute('data-letter');
    var ing = document.querySelector('.ingredientList--ingredient[id^="'+start+'"]');
	if (ing != null) {
	  var anchor = ing.getAttribute('id');
	  var a = document.createElement('a');
	  a.setAttribute('href', '#' + anchor);
	  a.setAttribute('data-offset', 200);
	  letter.parentNode.insertBefore(a, letter);
	  a.appendChild(letter);
	}
  });

  } catch(e) { console.error(e); }
})();
})();
